class ThemeBuilder {
	createOrFindStyleElement () {
		let styleEl = document.querySelector('[data-from-template=true]')

		if (!styleEl) {
			styleEl = this.createStyleElement()
		}

		return styleEl.sheet
	}

	build (theme) {
		this.theme = theme
		this.stylesheet = this.createOrFindStyleElement()

		this.applyStylesheet()
	}

	// eslint-disable-next-line class-methods-use-this
	createStyleElement () {
		const styleEl = document.createElement('style')
		styleEl.setAttribute('data-from-template', 'true')

		styleEl.appendChild(document.createTextNode(''))
		document.head.appendChild(styleEl)

		return styleEl
	}

	computeStyleRules () {
		const themeParams = this.theme.params
		let stylesToInsert = ':root {'

		themeParams.forEach((param) => {
			const cssProperty = `--${param.param_name}`
			stylesToInsert += `${cssProperty}: ${param.param_value} !important;`
		})

		stylesToInsert += '}'

		return stylesToInsert
	}

	applyStylesheet () {
		const customStyleRules = this.computeStyleRules()

		this.stylesheet.insertRule(customStyleRules)
	}
}

export default new ThemeBuilder()



// WEBPACK FOOTER //
// ./src/common/utils/theme-builder.js